import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ArrayResponse} from '../models/array-response';
import {SendBackResult} from '../models/send-back-result';

import {AppSettingsService} from './app-settings.service';
import {BaseRestService} from './base-rest.service';
import {SharedModule} from '../shared.module';
import {SupportUsers} from '../models/support-users';

@Injectable({providedIn: SharedModule})
export class SupportUsersService extends BaseRestService {
  constructor(http: HttpClient, appSettingsService: AppSettingsService) { super(http, appSettingsService); }

  protected get className(): string { return 'SupportUsersService'; }

  protected get isAnonymous(): boolean { return false; }

  getList(): Observable<SendBackResult<ArrayResponse<SupportUsers>>> { return this.get<ArrayResponse<SupportUsers>>(`/Orders/SupportUsers`); }
}
